import {
  FinanceValueObjectsJournalDraftEntryStatusEnum,
  FinanceValueObjectsJournalEntryStatusEnum,
  FinanceValueObjectsJournalEntryTypeEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const mapTypeText = (key: FinanceValueObjectsJournalEntryTypeEnum) => {
  switch (key) {
    case 'bank':
      return i18n.t('finance.journal_entry.data.type.bank')
    case 'tax':
      return i18n.t('finance.journal_entry.data.type.tax')
    case 'merged_ledger_account':
      return i18n.t('finance.journal_entry.data.type.merged_ledger_account')
    case 'invoice':
      return i18n.t('finance.journal_entry.data.type.invoice')
    case 'bill':
      return i18n.t('finance.journal_entry.data.type.bill')
    case 'reconciliation':
      return i18n.t('finance.journal_entry.data.type.reconciliation')
    case 'receipt':
      return i18n.t('finance.journal_entry.data.type.receipt')
    case 'payroll_result':
      return i18n.t('finance.journal_entry.data.type.payroll')
    case 'credit_note':
      return i18n.t('finance.journal_entry.data.type.credit_note')
    case 'external':
      return i18n.t('finance.journal_entry.data.type.external')
    default:
      return key satisfies never
  }
}

export const mapStatusColor = (
  status?:
    | FinanceValueObjectsJournalDraftEntryStatusEnum
    | FinanceValueObjectsJournalEntryStatusEnum
) => {
  if (!status) return 'neutral'

  switch (status) {
    case 'published':
      return 'lime'
    case 'reversed':
    case 'ready_to_publish':
      return 'malibu'
    case 'draft':
      return 'grey'
    case 'unbalanced':
      return 'tangerine'
    default:
      return status satisfies never
  }
}

export const mapStatusName = (
  status?:
    | FinanceValueObjectsJournalDraftEntryStatusEnum
    | FinanceValueObjectsJournalEntryStatusEnum
) => {
  if (!status) return i18n.t('finance.journal_entry.data.status.draft')

  switch (status) {
    case 'published':
      return i18n.t('finance.journal_entry.data.status.published')
    case 'reversed':
      return i18n.t('finance.journal_entry.data.status.reversed')
    case 'draft':
      return i18n.t('finance.journal_entry.data.status.draft')
    case 'unbalanced':
      return i18n.t('finance.journal_entry.data.status.unbalanced')
    case 'ready_to_publish':
      return i18n.t('finance.journal_entry.data.status.ready_to_publish')
    default:
      return status satisfies never
  }
}

export const mapTooltipLabel = (
  status?:
    | FinanceValueObjectsJournalDraftEntryStatusEnum
    | FinanceValueObjectsJournalEntryStatusEnum
) => {
  if (!status) return i18n.t('finance.journal_entry.data.status.draft')

  switch (status) {
    case 'published':
      return i18n.t('finance.journal_entry.data.status.tool_tip.published')
    case 'reversed':
      return i18n.t('finance.journal_entry.data.status.tool_tip.reversed')
    case 'draft':
      return i18n.t('finance.journal_entry.data.status.tool_tip.draft')
    case 'unbalanced':
      return i18n.t('finance.journal_entry.data.status.tool_tip.unbalanced')
    case 'ready_to_publish':
      return i18n.t('finance.journal_entry.data.status.tool_tip.ready_to_publish')
    default:
      return status satisfies never
  }
}

export const getJournalEntryTypeOptions = () => {
  return [
    { label: i18n.t('finance.journal_entry.data.type.bank'), value: 'bank' },
    { label: i18n.t('finance.journal_entry.data.type.tax'), value: 'tax' },
    {
      label: i18n.t('finance.journal_entry.data.type.merged_ledger_account'),
      value: 'merged_ledger_account',
    },
    { label: i18n.t('finance.journal_entry.data.type.invoice'), value: 'invoice' },
    { label: i18n.t('finance.journal_entry.data.type.bill'), value: 'bill' },
    { label: i18n.t('finance.journal_entry.data.type.reconciliation'), value: 'reconciliation' },
    { label: i18n.t('finance.journal_entry.data.type.receipt'), value: 'receipt' },
    { label: i18n.t('finance.journal_entry.data.type.payroll'), value: 'payroll_result' },
    { label: i18n.t('finance.journal_entry.data.type.credit_note'), value: 'credit_note' },
  ]
}

export const getJournalEntryStatusOptions = () => {
  return [
    { label: i18n.t('finance.journal_entry.data.status.published'), value: 'published' },
    { label: i18n.t('finance.journal_entry.data.status.reversed'), value: 'reversed' },
  ]
}

export const getJournalEntryDraftStatusOptions = () => {
  return [
    { label: i18n.t('finance.journal_entry.data.status.draft'), value: 'draft' },
    { label: i18n.t('finance.journal_entry.data.status.unbalanced'), value: 'unbalanced' },
    {
      label: i18n.t('finance.journal_entry.data.status.ready_to_publish'),
      value: 'ready_to_publish',
    },
  ]
}
